import { formatToDollar, type SuretyAccountId } from "@inrev/common";
import { DateTime } from "luxon";
import { type FC, useState } from "react";
import { FinancialPeriodBundle } from "../hooks/useFinancialsMetrics";
import { EditableProfitabilityCard } from "./EditableProfitabilityCard";
import { FinancialMetricCard } from "./FinancialMetricCard";

export type ProfitabilityYTDCardProps = {
	accountId: SuretyAccountId;
	recentYTD?: FinancialPeriodBundle;
	isManual?: boolean;
	canEdit?: boolean;
};

export const ProfitabilityYTDCard: FC<ProfitabilityYTDCardProps> = ({
	accountId,
	recentYTD,
	isManual,
	canEdit = true,
}) => {
	const [startInEditMode, setStartInEditMode] = useState(false);

	const recentDate = (
		recentYTD?.period.periodEndDate
			? DateTime.fromISO(recentYTD.period.periodEndDate)
			: DateTime.now()
	).toFormat("MM/dd/yy");

	if (!recentYTD || isManual || startInEditMode) {
		return (
			<EditableProfitabilityCard
				testId="editable-profitability-ytd-card"
				label="Profitable (YTD)"
				accountId={accountId}
				isProfitable={recentYTD?.profitable}
				startInEditMode={startInEditMode}
				additionalInfo={`as of ${recentDate}`}
				onEditClose={() => setStartInEditMode(false)}
				readOnly={!canEdit}
			/>
		);
	}

	const recentNetProfit = recentYTD.incomeStatement?.view?.netProfit.allowed;
	const value = formatToDollar(recentNetProfit, { abbreviate: true, accounting: true });

	return (
		<FinancialMetricCard
			testId="profitability-ytd-card"
			label="Net Income (YTD)"
			value={value}
			additionalInfo={value && `as of ${recentDate}`}
			onEditClick={() => setStartInEditMode(true)}
		/>
	);
};
